import {EVENTS_NAME, TOTAL_PROFESSIONAL_LEAD_TRIGGERED_DETAIL} from '../../config.js'

const {LEAD_TRIGGERED_WHATSAPP_DETAIL} = EVENTS_NAME

// INPUT:  event='Lead Triggered', lead_type='Detail Ad Replied Whatsapp', seller_type='profesional'
// OUTPUT: ['Total Leads Detalle Profesionales', 'Lead Detalle Profesionales Whatsapp']

export const getWhatsappDetailEvents = ({event, properties, isProfessionalSeller}) => {
  const matches =
    event === LEAD_TRIGGERED_WHATSAPP_DETAIL.EVENT &&
    properties.lead_type === LEAD_TRIGGERED_WHATSAPP_DETAIL.LEAD_TYPE &&
    isProfessionalSeller

  if (!matches) return []

  return [TOTAL_PROFESSIONAL_LEAD_TRIGGERED_DETAIL, LEAD_TRIGGERED_WHATSAPP_DETAIL.EVENT_OPTIMIZELY_PROFESSIONAL]
}
